
import GenreMaker from '../anychart/genreMaker'; 

var FunnelChart = class FunnelChart extends GenreMaker {

    setData(state){
        console.log("entry funnel");
       
        super.setData(state);
        this.chart = anychart.funnel(this.data[0]);
        return this.chart;
    }

    createChart(){
        return null;
    }; 
};
    
GenreMaker.funnel = FunnelChart;

export var FunnelChart;



// WEBPACK FOOTER //
// ./src/anychart/funnelChart.js